import scrollIntoView from 'scroll-into-view-if-needed';

const SmoothScrollIntoView = () => {
	function scrollToLocation(target) {
		document.body.classList.add('smooth-scrolling');

		const element = document.getElementById(target);

		if (!element) {
			return;
		}

		// smooth scrolling set in _global.scss based on user animation preferences.
		scrollIntoView(element, {
			scrollMode: 'if-needed',
			behavior: 'auto',
			block: 'start',
			inline: 'start',
		});

		if (window.smoothScrollTimeout) {
			clearTimeout(window.smoothScrollTimeout);
		}

		window.smoothScrollTimeout = setTimeout(function () {
			document.body.classList.remove('smooth-scrolling');
		}, 1000);

		element.focus();
	}

	// get all links on a page that include a hash symbol. Ignore disabled links.
	const anchorLinks = document.querySelectorAll(
		'a[href^="#"]:not([href="#"]):not([href="#onetrust"])'
	);

	const initializeAnchorLinks = (anchors) => {
		anchors.forEach((anchor) => {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				const target = anchor.getAttribute('href').substring(1);
				scrollToLocation(target);
			});

			anchor.addEventListener('keydown', function (e) {
				if (' ' === e.key || 'Enter' === e.key) {
					e.preventDefault();
					const target = anchor.getAttribute('href').substring(1);
					scrollToLocation(target);
				}
			});
		});
	};

	if (anchorLinks.length > 0) {
		initializeAnchorLinks(anchorLinks);
	}

	const anchorLinksSet = new Set(anchorLinks);

	window.addEventListener('propel-filters-render-posts', function () {
		const additionalAnchorLinks = document.querySelectorAll(
			'a[href^="#"]:not([href="#"]):not([href="#onetrust"])'
		);

		additionalAnchorLinks.forEach((anchor) => {
			if (anchorLinksSet.has(anchor)) {
				return;
			}

			initializeAnchorLinks([anchor]);
		});
	});
};

export default SmoothScrollIntoView;
